import {Grid} from '@mui/material';

import {CommentForm} from '../NoteForm/CommentForm';

import {MatchActivityMetaData} from './MatchActivityMetaData';
import {MatchComment} from '../../../../../../types/MatchActivity';
import {UserMention} from '../../../../../../types/UserMention';

interface Props {
  comment: MatchComment;
  matchId: string;
  companyId: string;
  userId: string;
  userMentions: UserMention[];
}
export const MatchCommentRow = ({comment, matchId, companyId, userId, userMentions}: Props) => {
  const isReadOnly = comment.activityContent.authorId !== userId;

  return (
    <Grid
      container
      flexWrap='nowrap'
      id={`comment-${comment.activityContent.resourceId}`}
      sx={{
        borderRadius: '8px',
        bgcolor: 'white',
        p: 1,
      }}
    >
      <Grid item container gap='8px' flexDirection='column' flexGrow={1}>
        <MatchActivityMetaData
          date={comment.activityAt}
          authorName={comment.activityContent.authorName}
          activityType='note-authored'
        />
        <CommentForm
          readonly={isReadOnly}
          userId={userId}
          companyId={companyId}
          matchId={matchId}
          comment={comment}
          userMentions={userMentions}
        />
      </Grid>
    </Grid>
  );
};
